// @ts-nocheck
export class CurAwait {
	public cursorAwaitAdd() {
		document.getElementById('main-scroll')?.classList.add('!cursor-wait');
	}

	public cursorAwaitRemove() {
		document.getElementById('main-scroll')?.classList.remove('!cursor-wait');
	}
}
